/**
 * Abel Rove Customizer v2
 * Hybrid 3-step layout with layered preview
 */

(function() {
  'use strict';

  var root = document.querySelector('[data-abel-customizer]');
  if (!root) return;

  // Config
  var configUrl = root.dataset.configUrl;
  var imageMapUrl = root.dataset.imageMapUrl;
  var basePrice = parseInt(root.dataset.basePrice || '0', 10);

  // Elements
  var els = {
    form: root.querySelector('[data-abel-form]'),
    previewStack: root.querySelector('[data-preview-stack]'),
    previewBase: root.querySelector('[data-preview-base]'),
    priceDisplay: root.querySelector('[data-price-display]'),
    submitPrice: root.querySelector('[data-submit-price]'),
    error: root.querySelector('[data-error]'),
    summary: root.querySelector('[data-summary]'),
    // Step 1
    styleChoices: root.querySelector('[data-style-choices]'),
    sizeSelect: root.querySelector('[data-size-select]'),
    // Step 2
    finishSearch: root.querySelector('[data-finish-search]'),
    finishCategory: root.querySelector('[data-finish-category]'),
    finishSwatches: root.querySelector('[data-finish-swatches]'),
    finishInput: root.querySelector('[data-finish-input]'),
    // Step 3
    dragknobSwatches: root.querySelector('[data-dragknob-swatches]'),
    dragknobInput: root.querySelector('[data-dragknob-input]'),
    handleSelect: root.querySelector('[data-handle-select]'),
    engravingOption: root.querySelector('[data-engraving-option]'),
    engravingSelect: root.querySelector('[data-engraving-select]'),
    titaniumSelect: root.querySelector('[data-titanium-select]')
  };

  // State
  var config = null;
  var imageMap = null;
  var selections = {};
  var totalPrice = basePrice;

  // Option ID mapping
  var OPTION_IDS = {
    retrieve: '133',
    style: '162',
    finish: '131',
    size: '135',
    dragknob: '136',
    handle: '132',
    engraving: '137',
    titanium: '163'
  };

  // Initialize
  init();

  function init() {
    root.classList.add('is-loading');

    Promise.all([
      fetchJson(configUrl),
      fetchJson(imageMapUrl)
    ]).then(function(results) {
      config = results[0];
      imageMap = results[1];

      if (!config || !config.options) {
        console.error('Abel Customizer: Failed to load config');
        return;
      }

      buildOptions();
      setupEventListeners();
      root.classList.remove('is-loading');

      console.log('Abel Customizer: Initialized', {
        options: config.options.length,
        images: imageMap ? Object.keys(imageMap.allMatchesUrl || {}).length : 0
      });
    });
  }

  function fetchJson(url) {
    if (!url) return Promise.resolve(null);
    return fetch(url)
      .then(function(r) { return r.json(); })
      .catch(function(e) {
        console.error('Fetch error:', e);
        return null;
      });
  }

  function buildOptions() {
    var optionsMap = {};
    config.options.forEach(function(opt) {
      optionsMap[opt.option_id] = opt;
    });

    // Style (162)
    buildStyleCards(optionsMap[OPTION_IDS.style]);

    // Size (135)
    buildSelect(els.sizeSelect, optionsMap[OPTION_IDS.size]);

    // Finish (131)
    buildFinishSwatches(optionsMap[OPTION_IDS.finish]);

    // Drag Knob (136)
    buildSwatches(els.dragknobSwatches, optionsMap[OPTION_IDS.dragknob], 'dragknob');

    // Handle (132)
    buildSelect(els.handleSelect, optionsMap[OPTION_IDS.handle]);

    // Engraving (137)
    buildSelect(els.engravingSelect, optionsMap[OPTION_IDS.engraving]);

    // Titanium (163)
    buildSelect(els.titaniumSelect, optionsMap[OPTION_IDS.titanium]);
  }

  function buildStyleCards(option) {
    if (!option || !option.values || !els.styleChoices) return;

    els.styleChoices.innerHTML = '';

    option.values.forEach(function(val) {
      var card = document.createElement('label');
      card.className = 'style-card';

      var imgUrl = getImageUrl(OPTION_IDS.style, val.value_id) || val.swatch_image || '';

      card.innerHTML =
        '<input type="radio" name="properties[Style]" value="' + escapeHtml(val.label) + '" required ' +
          'data-option-id="' + OPTION_IDS.style + '" data-value-id="' + val.value_id + '" data-price="' + (val.price_delta || 0) + '">' +
        '<div class="style-card__inner">' +
          '<div class="style-card__image">' +
            (imgUrl ? '<img src="' + imgUrl + '" alt="' + escapeHtml(val.label) + '">' : '') +
          '</div>' +
          '<div class="style-card__label">' + escapeHtml(val.label) + '</div>' +
        '</div>';

      els.styleChoices.appendChild(card);
    });
  }

  function buildSelect(selectEl, option) {
    if (!option || !option.values || !selectEl) return;

    // Keep first placeholder option
    var placeholder = selectEl.querySelector('option');
    selectEl.innerHTML = '';
    if (placeholder) selectEl.appendChild(placeholder);

    option.values.forEach(function(val) {
      var opt = document.createElement('option');
      opt.value = val.label;
      opt.dataset.valueId = val.value_id;
      opt.dataset.price = val.price_delta || 0;

      var label = val.label;
      if (val.price_delta > 0) {
        label += ' (+$' + val.price_delta + ')';
      }
      opt.textContent = label;

      selectEl.appendChild(opt);
    });
  }

  function buildFinishSwatches(option) {
    if (!option || !option.values || !els.finishSwatches) return;

    els.finishSwatches.innerHTML = '';

    option.values.forEach(function(val) {
      var swatch = createSwatch(val, OPTION_IDS.finish, 'finish');
      swatch.dataset.category = categorizeFinish(val.label, val.price_delta);
      swatch.dataset.searchText = val.label.toLowerCase();
      els.finishSwatches.appendChild(swatch);
    });
  }

  function buildSwatches(container, option, type) {
    if (!option || !option.values || !container) return;

    container.innerHTML = '';

    option.values.forEach(function(val) {
      var swatch = createSwatch(val, option.option_id, type);
      container.appendChild(swatch);
    });
  }

  function createSwatch(val, optionId, type) {
    var swatch = document.createElement('div');
    swatch.className = 'abel-swatch';
    swatch.dataset.valueId = val.value_id;
    swatch.dataset.optionId = optionId;
    swatch.dataset.label = val.label;
    swatch.dataset.price = val.price_delta || 0;
    swatch.dataset.type = type;

    // Get color from label for placeholder
    var colorClass = getColorClass(val.label);

    var priceText = '';
    if (val.price_delta > 0) {
      priceText = '<span class="abel-swatch__price">+$' + val.price_delta + '</span>';
    }

    swatch.innerHTML =
      '<div class="abel-swatch__color ' + colorClass + '"></div>' +
      '<div class="abel-swatch__label">' + escapeHtml(truncate(val.label, 20)) + priceText + '</div>';

    return swatch;
  }

  function getColorClass(label) {
    var l = label.toLowerCase();
    if (l.includes('black')) return 'color-black';
    if (l.includes('blue') && l.includes('deep')) return 'color-navy';
    if (l.includes('blue')) return 'color-blue';
    if (l.includes('red') || l.includes('ruby')) return 'color-red';
    if (l.includes('green') || l.includes('olive')) return 'color-green';
    if (l.includes('gold') || l.includes('bronze') || l.includes('amber')) return 'color-gold';
    if (l.includes('silver') || l.includes('grey') || l.includes('gray')) return 'color-silver';
    if (l.includes('purple') || l.includes('violet')) return 'color-purple';
    if (l.includes('orange') || l.includes('copper')) return 'color-orange';
    if (l.includes('teal') || l.includes('turquoise')) return 'color-teal';
    if (l.includes('pink') || l.includes('rose')) return 'color-pink';
    if (l.includes('brown') || l.includes('walnut') || l.includes('wood')) return 'color-brown';
    if (l.includes('white') || l.includes('pearl')) return 'color-white';
    if (l.includes('yellow')) return 'color-yellow';
    if (l.includes('trout') || l.includes('fish') || l.includes('salmon') || l.includes('bass') || l.includes('tarpon')) return 'color-fish';
    if (l.includes('flag') || l.includes('usa') || l.includes('america')) return 'color-flag';
    if (l.includes('fade')) return 'color-fade';
    return 'color-default';
  }

  function categorizeFinish(label, price) {
    var l = label.toLowerCase();
    if (price >= 600) return 'artist';
    if (price >= 500 || l.includes('flag') || l.includes('usa') || l.includes('cuba') || l.includes('bahama')) return 'flag';
    if (price >= 400 || l.includes('trout') || l.includes('salmon') || l.includes('bass') || l.includes('tarpon') || l.includes('bone')) return 'fish';
    if (price >= 300 || l.includes('fade')) return 'fade';
    if (price >= 100 && l.includes('satin')) return 'satin';
    if (price >= 100) return 'premium';
    return 'base';
  }

  function setupEventListeners() {
    // Retrieve radio buttons
    root.querySelectorAll('[name="properties[Retrieve]"]').forEach(function(input) {
      input.addEventListener('change', function() {
        selections.retrieve = { label: this.value, price: 0 };
        updatePrice();
      });
    });

    // Style cards
    if (els.styleChoices) {
      els.styleChoices.addEventListener('change', function(e) {
        if (e.target.matches('input[type="radio"]')) {
          selections.style = {
            label: e.target.value,
            valueId: e.target.dataset.valueId,
            price: parseFloat(e.target.dataset.price) || 0
          };
          updatePreview();
          updatePrice();
        }
      });
    }

    // Size select
    if (els.sizeSelect) {
      els.sizeSelect.addEventListener('change', function() {
        var opt = this.options[this.selectedIndex];
        if (opt && opt.value) {
          selections.size = {
            label: opt.value,
            valueId: opt.dataset.valueId,
            price: parseFloat(opt.dataset.price) || 0
          };
        } else {
          delete selections.size;
        }
        updatePreview();
        updatePrice();
      });
    }

    // Finish swatches
    if (els.finishSwatches) {
      // Preload image on hover for instant loading
      els.finishSwatches.addEventListener('mouseenter', function(e) {
        var swatch = e.target.closest('.abel-swatch');
        if (swatch && swatch.dataset.valueId) {
          preloadImage(OPTION_IDS.finish, swatch.dataset.valueId);
        }
      }, true);

      els.finishSwatches.addEventListener('click', function(e) {
        var swatch = e.target.closest('.abel-swatch');
        if (!swatch) return;

        // Deselect all
        els.finishSwatches.querySelectorAll('.abel-swatch').forEach(function(s) {
          s.classList.remove('is-selected');
        });

        // Select this one
        swatch.classList.add('is-selected');

        var category = swatch.dataset.category;

        selections.finish = {
          label: swatch.dataset.label,
          valueId: swatch.dataset.valueId,
          price: parseFloat(swatch.dataset.price) || 0,
          category: category
        };

        if (els.finishInput) {
          els.finishInput.value = swatch.dataset.label;
        }

        // Show engraving option only for base colors
        updateEngravingVisibility(category === 'base');

        updatePreview();
        updatePrice();
      });
    }

    // Finish search
    if (els.finishSearch) {
      els.finishSearch.addEventListener('input', debounce(filterFinishes, 200));
    }

    // Finish category filter
    if (els.finishCategory) {
      els.finishCategory.addEventListener('change', filterFinishes);
    }

    // Drag knob swatches
    if (els.dragknobSwatches) {
      els.dragknobSwatches.addEventListener('click', function(e) {
        var swatch = e.target.closest('.abel-swatch');
        if (!swatch) return;

        els.dragknobSwatches.querySelectorAll('.abel-swatch').forEach(function(s) {
          s.classList.remove('is-selected');
        });
        swatch.classList.add('is-selected');

        selections.dragknob = {
          label: swatch.dataset.label,
          valueId: swatch.dataset.valueId,
          price: parseFloat(swatch.dataset.price) || 0
        };

        if (els.dragknobInput) {
          els.dragknobInput.value = swatch.dataset.label;
        }

        updatePreview();
        updatePrice();
      });
    }

    // Other selects
    ['handle', 'engraving', 'titanium'].forEach(function(type) {
      var select = els[type + 'Select'];
      if (select) {
        select.addEventListener('change', function() {
          var opt = this.options[this.selectedIndex];
          if (opt && opt.value) {
            selections[type] = {
              label: opt.value,
              valueId: opt.dataset.valueId,
              price: parseFloat(opt.dataset.price) || 0
            };
          } else {
            delete selections[type];
          }
          // Update preview for engraving (it has layer images)
          if (type === 'engraving') {
            console.log('Engraving selected:', selections.engraving);
            updatePreview();
          }
          updatePrice();
        });
      }
    });

    // Step 3 toggle
    var toggleBtn = root.querySelector('[data-toggle-step="3"]');
    var step3Content = root.querySelector('[data-step-content="3"]');
    if (toggleBtn && step3Content) {
      toggleBtn.addEventListener('click', function() {
        var step = toggleBtn.closest('.abel-step');
        var isOpen = step.classList.contains('is-open');

        if (isOpen) {
          step.classList.remove('is-open');
          step3Content.style.display = 'none';
        } else {
          step.classList.add('is-open');
          step3Content.style.display = '';
        }
      });
    }

    // Form submit
    if (els.form) {
      els.form.addEventListener('submit', function(e) {
        els.error.textContent = '';

        // Validate required
        if (!selections.retrieve) {
          e.preventDefault();
          els.error.textContent = 'Please select a retrieve direction.';
          return;
        }
        if (!selections.style) {
          e.preventDefault();
          els.error.textContent = 'Please select a style.';
          return;
        }
        if (!selections.finish) {
          e.preventDefault();
          els.error.textContent = 'Please select a finish.';
          return;
        }
      });
    }
  }

  function filterFinishes() {
    var searchText = (els.finishSearch ? els.finishSearch.value : '').toLowerCase();
    var category = els.finishCategory ? els.finishCategory.value : '';

    els.finishSwatches.querySelectorAll('.abel-swatch').forEach(function(swatch) {
      var matchesSearch = !searchText || swatch.dataset.searchText.includes(searchText);
      var matchesCategory = !category || swatch.dataset.category === category;
      swatch.style.display = (matchesSearch && matchesCategory) ? '' : 'none';
    });
  }

  function updateEngravingVisibility(show) {
    if (!els.engravingOption) return;

    if (show) {
      els.engravingOption.style.display = '';
    } else {
      els.engravingOption.style.display = 'none';
      // Clear engraving selection when hidden
      if (els.engravingSelect) {
        els.engravingSelect.selectedIndex = 0;
      }
      delete selections.engraving;
    }
  }

  // Preload cache
  var preloadedImages = {};

  function preloadImage(optionId, valueId) {
    var key = optionId + '_' + valueId;
    if (preloadedImages[key]) return;

    var url = getImageUrl(optionId, valueId);
    if (!url) return;

    var img = new Image();
    img.src = url;
    preloadedImages[key] = true;
  }

  function updatePreview() {
    if (!imageMap || !imageMap.allMatchesUrl || !els.previewStack) return;

    // Remove existing layers
    els.previewStack.querySelectorAll('.preview-layer').forEach(function(layer) {
      layer.remove();
    });

    // Layer order
    var layers = [
      { key: 'style', optionId: OPTION_IDS.style },
      { key: 'size', optionId: OPTION_IDS.size },
      { key: 'finish', optionId: OPTION_IDS.finish },
      { key: 'engraving', optionId: OPTION_IDS.engraving },
      { key: 'dragknob', optionId: OPTION_IDS.dragknob }
    ];

    var hasLayers = false;

    layers.forEach(function(layer) {
      var sel = selections[layer.key];
      if (!sel || !sel.valueId) return;

      var url = getImageUrl(layer.optionId, sel.valueId);
      if (!url) return;

      hasLayers = true;
      var img = document.createElement('img');
      img.className = 'preview-layer';
      img.src = url;
      img.alt = '';
      els.previewStack.appendChild(img);
    });

    // Show/hide base image
    if (els.previewBase) {
      els.previewBase.style.opacity = hasLayers ? '0' : '1';
    }
  }

  function getImageUrl(optionId, valueId) {
    if (!imageMap || !imageMap.allMatchesUrl) return null;
    var optionMap = imageMap.allMatchesUrl[optionId];
    if (!optionMap) return null;
    return optionMap[valueId] || null;
  }

  function updatePrice() {
    var addons = 0;

    Object.keys(selections).forEach(function(key) {
      var sel = selections[key];
      if (sel && sel.price) {
        addons += sel.price * 100; // Convert to cents
      }
    });

    totalPrice = basePrice + addons;

    var formatted = formatMoney(totalPrice);

    if (els.priceDisplay) {
      els.priceDisplay.textContent = formatted;
    }
    if (els.submitPrice) {
      els.submitPrice.textContent = formatted;
    }

    updateSummary();
  }

  function updateSummary() {
    if (!els.summary) return;

    var parts = [];
    if (selections.style) parts.push(selections.style.label);
    if (selections.finish) parts.push(selections.finish.label);

    els.summary.textContent = parts.length ? parts.join(' / ') : '';
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;')
              .replace(/</g, '&lt;')
              .replace(/>/g, '&gt;')
              .replace(/"/g, '&quot;');
  }

  function truncate(str, len) {
    if (!str || str.length <= len) return str;
    return str.substring(0, len) + '...';
  }

  function debounce(fn, delay) {
    var timer;
    return function() {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function() { fn.apply(null, args); }, delay);
    };
  }

})();
